import React, {FC} from 'react'
import {toAbsoluteUrl} from '../../../../helpers'
import {browsers, BrowsersType, ConversionClicksNumberClicks} from '../../../../../app/@types'

type Props = {
    data: ConversionClicksNumberClicks[]
}

const Row: FC<Props> = ({data}) => {

    const getBrowser = (browserName: string): string => {
        const browser = browserName.toLowerCase()
        if (browsers.includes(browser as BrowsersType)) {
            return `/media/browsers/${browser.toLowerCase()}.png`
        }
        return `/media/browsers/generic-browser.png`
    };

    return (
        <>
            {
                data.map((item, index) => (
                    <tr key={index}>
                        <td className="ps-4">{item.dateHour}</td>
                        <td>{item.eventCount}</td>
                        <td>{item.sessionSource}</td>
                        <td>{item.pagePath}</td>
                        <td>{item.city}, {item.country}</td>
                        <td>
                            <div className="symbol symbol-30px me-2">
                    <span className="symbol-label">
                        <img
                            className="h-50 align-self-center"
                            src={toAbsoluteUrl(getBrowser(item.browser))}
                            alt={item.browser}
                        />
                    </span>
                            </div>
                            {item.browser}
                        </td>
                        <td>{item.platformDeviceCategory}</td>
                    </tr>
                ))
            }
        </>
    )
}

export {Row}